import SlideCardStyle, { SlideCardProps } from './style';

const SlideCard = ({ frontElement, backElement, size, cardStyle }: SlideCardProps) => (
  <SlideCardStyle size={size} style={cardStyle}>
    <div className="card-container">
      <div className="card">{frontElement}</div>
      <div className="card">{backElement}</div>
    </div>
  </SlideCardStyle>
);

export default SlideCard;
